import React from 'react';
import { AI_ALERTS_HELP } from '@src/utils/help/links';

export const Notice = () => {
  return (
    <div>
      For best results, choose metrics which have:
      <ul style={{ fontSize: 14, margin: '0 0 5px -20px' }}>
        <li>A stable baseline during normal behavior</li>
        <li>Significant volume (at least 25 devices per minute)</li>
        <li>Spike increases on degradation (failure rate, not success rate)</li>
      </ul>
      <p>
        Depending on traffic levels, new or updated metric definitions take up to 4 days to
        establish their new baseline.
      </p>
      <p>
        Please note that AI alerts currently do not support the metrics which are disabled below. We
        are actively developing new algorithms to support them.
        <a href={AI_ALERTS_HELP} target="_blank" rel="noopener noreferrer">
          {' Learn more'}
        </a>
      </p>
    </div>
  );
};
